
<form class="mce-form-section">

    <div class="mce-form-section-title">Default Values</div>

    <div>
        <mat-form-field class="w-full">
            <mat-select [formField]="form().country">
                @for (country of countries(); track country.value) {
                <mat-option [value]="country.value">{{country.label}}</mat-option>
                }
            </mat-select>
            <span matSuffix>
                @if (!flag64Resource.isLoading()) {
                <img [src]="'data:image/png;base64,' + flag64()" class="project-edit-flag64">
                }
            </span>
        </mat-form-field>
    </div>

    <div class="mce-form-field-group">

        <div>
            <mat-form-field class="w-full">
                <mat-label>soil thermal resistivity</mat-label>
                <input matInput type="number" placeholder="soil thermal resistivity"
                       [formField]="form().soilThermalResistivity" />
                <span matSuffix>K.m/W</span>
                @for (error of form().soilThermalResistivity().errors(); track error.kind ) {
                <mat-error>  {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="w-full">
                <mat-label>ground temperature</mat-label>
                <input matInput type="number" placeholder="ground temperature"
                       [formField]="form().groundAmbientTemperature" />
                <span matSuffix>°C</span>
                @for (error of form().groundAmbientTemperature().errors(); track error.kind ) {
                <mat-error>  {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="w-full">
                <mat-label>air temperature</mat-label>
                <input matInput type="number" placeholder="air temperature"
                       [formField]="form().airAmbientTemperature" />
                <span matSuffix>°C</span>
                @for (error of form().airAmbientTemperature().errors(); track error.kind ) {
                <mat-error>  {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>


    </div>

</form>

